/**
 * The one lesson in getting around (NAVIGATION.md §4).
 *
 * The orbit menu and the swipe are both new gestures, and a gesture nobody
 * mentions is a gesture nobody finds. So the first time somebody lands on a
 * screen with the orb in it, the orb pulses twice and says what it is for —
 * once, ever, and then never again on any device.
 *
 * It goes away at the first touch of anything at all, including the orb itself,
 * which means the person who already understood it loses nothing to it.
 */

const COPY = 'Tap the orb to move around — or swipe left and right.'

/** Undoes whatever the hint currently on screen has attached. */
let close = null

/**
 * @param {HTMLElement} button the header's orb button
 * @param {{onDismissed: () => void}} options
 */
export function showOrbitHint(button, { onDismissed }) {
  if (close !== null) return

  const header = button.closest('.hdr')

  if (header === null) return

  const tip = document.createElement('p')
  tip.className = 'orbit-hint'
  tip.setAttribute('role', 'status')
  tip.textContent = COPY
  header.append(tip)
  button.classList.add('hdr__orb--hinting')

  close = (taught) => {
    close = null
    document.removeEventListener('pointerdown', dismiss, true)
    document.removeEventListener('keydown', dismiss, true)
    button.classList.remove('hdr__orb--hinting')
    tip.classList.add('orbit-hint--out')
    window.setTimeout(() => tip.remove(), 220)

    if (taught) onDismissed()
  }

  function dismiss() {
    close?.(true)
  }

  // Capture, so this runs before whatever was actually tapped gets to act — the
  // hint must not be on screen a moment longer than the first touch.
  document.addEventListener('pointerdown', dismiss, true)
  document.addEventListener('keydown', dismiss, true)
}

/**
 * The screen is being replaced under it. Take the hint down without counting it
 * as taught, so it comes back on the screen that replaces this one.
 */
export function cancelOrbitHint() {
  close?.(false)
}
